module.exports = __webpack_public_path__ + "media/styles/images/svg/play-overlay-teal-7c95fd21b89b36fceeb7111802fa210b.svg";